import { NavLink, Outlet } from 'react-router-dom';
import {
  User,
  Shield,
  Bell,
  Database,
  CreditCard,
  ChevronRight,
} from 'lucide-react';
import { clsx } from 'clsx';
import PageHeader from '@components/layout/PageHeader';

const settingsNav = [
  { label: 'Perfil', href: '/app/settings/profile', icon: User, description: 'Nome, avatar e preferências' },
  { label: 'Segurança', href: '/app/settings/security', icon: Shield, description: 'Senha e sessões ativas' },
  { label: 'Notificações', href: '/app/settings/notifications', icon: Bell, description: 'Alertas e lembretes' },
  { label: 'Dados', href: '/app/settings/data', icon: Database, description: 'Exportar e excluir conta' },
  { label: 'Assinatura', href: '/app/settings/billing', icon: CreditCard, description: 'Plano e pagamento' },
];

const Settings = () => {
  return (
    <div>
      <PageHeader title="Configurações" subtitle="Gerencie sua conta e preferências" />

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Sidebar de navegação */}
        <aside className="lg:w-64 flex-shrink-0">
          <nav className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden">
            {settingsNav.map((item, idx) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 px-4 py-3 transition-colors group',
                    idx > 0 && 'border-t border-gray-100 dark:border-gray-700',
                    isActive
                      ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-400'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50'
                  )
                }
              >
                <div className={clsx(
                  'w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0',
                  'bg-gray-100 dark:bg-gray-700 group-[.active]:bg-primary-100 dark:group-[.active]:bg-primary-900/30'
                )}>
                  <item.icon size={18} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium">{item.label}</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{item.description}</p>
                </div>
                <ChevronRight size={16} className="text-gray-400 flex-shrink-0" />
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Conteúdo da sub-página */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Settings;
